module.exports = __webpack_public_path__ + "static/media/light-divider.bf511a33.png";